// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hotel-Board {
  display: grid;
  grid-template-columns: 78vw auto;
  gap: 1vw;
  margin-top: 0.7vw;
}
.hotel-Scene {
  display: grid;
  position: relative;
  place-items: center;
  box-shadow:
    0 4px 8px 0 #0003,
    0 6px 20px 0 #00000030;
  border: 2px solid #1a6a7c;
}

.hotel-board-loading {
  width: 100%;
  height: 37.5vw;
  font-size: 2vw;
  display: grid;
  justify-content: center;
  align-items: center;
  background: white;
}
.hotel-BackgroundImg {
  width: 100%;
  min-height: max-content;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Stevehotel/styles/HotelBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB;;0BAEwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB","sourcesContent":[".hotel-Board {\n  display: grid;\n  grid-template-columns: 78vw auto;\n  gap: 1vw;\n  margin-top: 0.7vw;\n}\n.hotel-Scene {\n  display: grid;\n  position: relative;\n  place-items: center;\n  box-shadow:\n    0 4px 8px 0 #0003,\n    0 6px 20px 0 #00000030;\n  border: 2px solid #1a6a7c;\n}\n\n.hotel-board-loading {\n  width: 100%;\n  height: 37.5vw;\n  font-size: 2vw;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  background: white;\n}\n.hotel-BackgroundImg {\n  width: 100%;\n  min-height: max-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
